const initState = {
  isRemoving: false,
  error: null,
}

export default initState
